import {
  useState,
  useContext,
  useCallback,
  useRef,
  useEffect,
  useMemo,
} from "react";
import {
  Card,
  CardContent,
  TextField,
  Button as ButtonUi,
  Box,
  InputLabel,
  Select,
  MenuItem,
  TextareaAutosize,
  SelectChangeEvent,
  Grid,
  Modal,
  IconButton,
  Typography,
  Tooltip,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  Alert,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Stack,
  Paper,
  Chip,
} from "@mui/material";
import { Button } from "../Button";
import { Header } from "../Header";
import {
  Container,
  Form,
  Input,
  InputStyled,
  SubTitle,
  Title,
  Load,
  LoadFile,
  ContainerForm,
  ContainerTextArea,
} from "./style";
import { Spinner } from "../../ui/Spinner";
import { Close, UploadFile, Add, InfoOutlined } from "@mui/icons-material";
import { cnpjMask, mascaraMoeda, maskNumber } from "../../utils/mask";
import { apiOperation, apiExtractor, headers } from "../../services/api";
import { Error } from "../Error";
import { Loading } from "../Loading";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../ErrorModal";
import { getSessionUser } from "../../utils/users";
import { IUser } from "../Login/ILogin";
import { Empresas } from "../../utils/empresa";
import React from "react";
import { Listar } from "../../models/analise";
import { HeaderModal } from "../Results/style";
import { useUnsavedChanges } from "../../data/analiseContext";
import { NumericFormat } from "react-number-format";
import { Resultado } from "../../models/base/basic";
import {
  TIPOS_GARANTIA_RDP,
  CODIGO_GARANTIA_OUTROS,
  mapLabelsParaCodigosGarantia,
  getLabelTipoGarantia,
  getGrupoTipoGarantia,
  extrairTiposDisponiveisDasComposicoes,
  buscarComposicaoAtivaPorTipos,
  parseChaveCombinacaoGarantia,
} from "../../constants/garantiasRdp";
import { ConfiguracaoGarantiaComposicao } from "../../models/configuracao";
import { Conta } from "../../models/notouch/conta";

interface ConfiguracaoCompletaGarantias {
  configuracaoGarantiaComposicao?: ConfiguracaoGarantiaComposicao[];
}

interface ISegmento {
  segmentoId: string;
  empresaId: string;
  risco: string;
  segmento: string;
  porcentagem: number;
}

interface IArquivoGenerico {
  id: number;
  load?: boolean;
  name?: string | null;
  tipoDocumento: string;
}

interface IFormfind {
  tipoAnalise: EtipoFluxoAnalise;
  cnpj: string;
  valorSolicitado: string;
  faturamentoMedioMensal: string;
  prazoSolicitado: string;
  numeroFuncionarios: string;
  classificacaoInterna: EclassificacaoInterna | "";
  parecerComercial: string;
  tipoEmpresa: string;
  cnpjMatriz: string;
  ultimoCredito: string;
  urlSite: string;
  tipoDeAnalise: EtipoAnalise | "";
  tempoCooperativa: string;
  comprometimentoRenda: string;
  postoAtendimento: string;
  tipoFuncionario: string;
  faturamento: string;
  cnpjSolidario: string;
  razaoSocial: string;
  demanda: Edemanda | "";
  tempoRelacionamento: string;
  percentualEmbalagem: string;
  valorMedioCompradoTrombini: string;
  segmento: string;
  segmentoId?: string;
  prazoDePagamento: string;
  temGarantia: boolean;
  tiposGarantia: string[];
  percentualCoberturaGarantia: string;
  descricaoGarantia: string;
}

enum EclassificacaoInterna {
  Otimo = "otimo",
  Bom = "bom",
  Ruim = "ruim",
}

enum EtipoAnalise {
  Corporate = "Corporate",
  Revenda = "Revenda",
  Aditivo = "Aditivo",
}

enum EtipoFluxoAnalise {
  Completa = 1,
  Simplificada = 4,
}

enum EtipoDocumento {
  BalancoDre = "balanco e dre",
}

enum Edemanda {
  ComDemanda = "Com demanda",
  SemDemanda = "Sem Demanda",
}

const VALIDATION_MSG_REPRESENTATIVIDADE =
  'Quando a opção "Calcular limite por representatividade" está marcada, todos os 5 campos relacionados (Segmento, % Embalagem, Custo médio, Valor médio e Prazo) devem ser preenchidos.';

const VALIDATION_MSG_GARANTIAS_RDP =
  'Quando "Tem Garantia?" estiver como Sim, é obrigatório informar pelo menos um tipo de garantia e o percentual de cobertura da garantia (número inteiro entre 0 e 100).';

const VALIDATION_MSG_GARANTIAS_OUTROS_RDP =
  'Quando o tipo "Outros" estiver selecionado, informe a descrição da garantia.';

const VALIDATION_MSG_GARANTIAS_COMBINACAO_RDP =
  "A combinação de tipos de garantia selecionada não está cadastrada na parametrização. Ajuste os tipos conforme as composições ativas ou atualize a parametrização.";

const VALIDATION_MSG_GARANTIAS_SEM_PARAMETRIZACAO_RDP =
  "Não há composições de garantia ativas cadastradas na parametrização. Cadastre-as em Parametrização antes de analisar com garantia.";

function DocumentacaoRegrasTooltip() {
  return (
    <Box
      sx={{
        maxWidth: 460,
        p: 0.5,
        "& ul": { pl: 2, my: 1 },
        "& li": { listStyleType: "disc", mb: 0.5 },
      }}
    >
      <Typography variant="subtitle2" component="p" fontWeight={600}>
        Documentação obrigatória
      </Typography>
      <ul>
        <li>
          Envie sempre DRE e balanço juntos — é necessário ter os dois
          demonstrativos (um arquivo único ou PDFs separados).
        </li>
        <li>Não inclua balancete (não suportado).</li>
        <li>
          Os documentos precisam estar padronizados e legíveis (ex.: campo
          &quot;Ano&quot; claro e estruturado).
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Caso algum dado não seja extraído corretamente ou o documento esteja
        ilegível, a análise pode seguir em <strong>esteira</strong>, com prazo
        de até <strong>2h</strong> para retorno.
      </Typography>
    </Box>
  );
}

let usuarioLogado: IUser | null = null;

interface response {
  erro: boolean;
  erros: string[];
  statusCode: number;
  valor: OpcaoConfiguracao[];
}

interface OpcaoConfiguracao {
  opcaoParametroId: string;
  descricaoParamentro: string;
  peso: number;
  fator: number;
  ativo: boolean;
  tipoParametro: number;
}

interface HistoryResult {
  found: boolean;
  analiseId?: string;
}

const dateMask = (value: string) => {
  // Remove any non-numeric characters
  value = value.replace(/\D/g, "");

  // Format the value as dd-MM-yyyy
  if (value.length > 2) {
    value = value.slice(0, 2) + "-" + value.slice(2);
  }
  if (value.length > 5) {
    value = value.slice(0, 5) + "-" + value.slice(5);
  }
  if (value.length > 10) {
    value = value.slice(0, 10);
  }
  return value;
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "18px",
};

interface ModalState {
  open: boolean;
  title: string;
  message: string;
  existingId?: string;
}

const pageCardSx = {
  maxWidth: "100%",
  borderRadius: "20px",
  boxShadow: "var(--elevation-3)",
  border: "1px solid var(--border-default)",
  overflow: "hidden",
  background:
    "linear-gradient(180deg, var(--surface-raised) 0%, var(--surface-canvas) 55%, var(--surface-sunken) 100%)",
};

const pageCardContentSx = {
  px: { xs: 2, sm: 3, md: 4 },
  py: { xs: 2.5, sm: 3, md: 3.5 },
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--border-default)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--border-hairline)",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--action-accent-surface)",
    borderWidth: "1.5px",
  },
  "& .MuiAlert-root": {
    borderRadius: "14px",
  },
};

const formSectionPanelSx = {
  mt: 2,
  mb: 1,
  width: "100%",
  p: { xs: 2, sm: 2.5 },
  borderRadius: "16px",
  bgcolor: "var(--surface-raised)",
  border: "1px solid var(--border-default)",
  boxShadow: "var(--elevation-2)",
};

const documentCardContentSx = {
  pt: 4,
  pb: 3,
  px: { xs: 2, sm: 2.5 },
  mt: 1,
  borderTop: "1px solid var(--border-default)",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

const documentSectionStackSx = {
  width: "100%",
  maxWidth: { xs: "100%", sm: 520, md: 600, lg: 640 },
  alignSelf: "flex-start",
};

export const NewSearch = () => {
  const isNoTouch = getSessionUser()?.perfil === "Agencia-brt";
  const mensagemCpfNoTouch =
    "Análises NoTouch estão disponíveis apenas para CNPJ.";
  const cpfBloqueadoNoTouch = (value: string) =>
    isNoTouch && value.replace(/\D/g, "").length === 11;
  let navigate = useNavigate();
  const [form, setForm] = useState<IFormfind>({
    tipoAnalise: EtipoFluxoAnalise.Completa,
    cnpj: "",
    valorSolicitado: "",
    faturamentoMedioMensal: "",
    prazoSolicitado: "",
    numeroFuncionarios: "",
    classificacaoInterna: "",
    parecerComercial: "",
    ultimoCredito: "",
    tipoEmpresa: "",
    cnpjMatriz: "",
    urlSite: "",
    tipoDeAnalise: "",
    tempoCooperativa: "",
    comprometimentoRenda: "",
    postoAtendimento: "",
    tipoFuncionario: "",
    faturamento: "",
    cnpjSolidario: "",
    razaoSocial: "",
    demanda: "",
    tempoRelacionamento: "",
    percentualEmbalagem: "",
    valorMedioCompradoTrombini: "",
    segmento: "",
    segmentoId: "",
    prazoDePagamento: "",
    temGarantia: false,
    tiposGarantia: [],
    percentualCoberturaGarantia: "",
    descricaoGarantia: "",
  });
  const [segmentos, setSegmentos] = useState<ISegmento[]>([]);
  const [segmentoSelecionado, setSegmentoSelecionado] =
    useState<ISegmento | null>(null);
  const [empresaId, setEmpresaId] = useState(null);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [titleError, setTitleError] = useState<string>("");
  const [hasError, setHasError] = useState<boolean>(true);
  const [errorOnExit, setErrorOnExit] = useState<() => void>(
    () => updateAnaliseStatus,
  );
  const [isMatriz, setTipoEmpresa] = useState<boolean>(true);
  const [hasLoad, setHasLoad] = useState<boolean>(false);
  const [hasLoadDocumento, setHasLoadDocumento] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [tresBalancos, setTresBalancos] = useState<string>("");
  const [tresBalancosLoad, setTresBalancosLoad] = useState<boolean>(false);
  const [analiseId, setAnaliseId] = useState<string>("");
  const [listNewUpload, setListNewUpload] = useState<IArquivoGenerico[]>([
    {
      id: 1,
      name: null,
      load: false,
      tipoDocumento: EtipoDocumento.BalancoDre,
    },
  ]);
  const [messagesLoading, setMessagesLoading] = useState<string>("");
  const maxSize = 50 * 1024 * 1024;
  const [carregaItensSimpress, setCarregaItens] = useState(false);
  const [carregaItensBrf, setCarregaItensBrf] = useState(false);
  const [carregaItensTriunfante, setCarregaItensTriunfante] = useState(false);
  const [carregaItensBRT, setCarregaItensBRT] = useState(false);
  const [carregaItensAgenciaBRT, setcarregaItensAgenciaBRT] = useState(false);
  const [carregaItensJnsSeguradora, setCarregaItensJnsSeguradora] =
    useState(false);
  const [carregarItensTrombini, setCarregarItensTrombini] = useState(false);
  const [carregaItensRdp, setCarregaItensRdp] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [isValidSolidario, setIsValidSolidario] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [opcaoConfiguracao, setOpcaoConfiguracao] = useState<
    OpcaoConfiguracao[]
  >([]);
  const { setHasUnsavedChanges } = useUnsavedChanges();
  const [
    calcularLimitePorRepresentatividade,
    setCalcularLimitePorRepresentatividade,
  ] = useState(false);
  const [validationModalOpen, setValidationModalOpen] = useState(false);
  const [validationModalMessage, setValidationModalMessage] = useState("");
  const [composicoesGarantia, setComposicoesGarantia] = useState<
    ConfiguracaoGarantiaComposicao[]
  >([]);
  const [composicoesGarantiaCarregadas, setComposicoesGarantiaCarregadas] =
    useState(false);

  const formRef = useRef(form);
  const calcularLimitePorRepresentatividadeRef = useRef(
    calcularLimitePorRepresentatividade,
  );

  useEffect(() => {
    formRef.current = form;
  }, [form]);

  useEffect(() => {
    calcularLimitePorRepresentatividadeRef.current =
      calcularLimitePorRepresentatividade;
  }, [calcularLimitePorRepresentatividade]);

  const composicoesGarantiaAtivas = useMemo(
    () => composicoesGarantia.filter((c) => c.ativo && c.chaveCombinacao),
    [composicoesGarantia],
  );

  const tiposGarantiaDisponiveis = useMemo(
    () => extrairTiposDisponiveisDasComposicoes(composicoesGarantiaAtivas),
    [composicoesGarantiaAtivas],
  );

  const resumoCombinacoesGarantia = useMemo(
    () =>
      composicoesGarantiaAtivas
        .map((c) => {
          const tipos = parseChaveCombinacaoGarantia(c.chaveCombinacao)
            .map(getLabelTipoGarantia)
            .join(" + ");
          return `${tipos} (fator ${c.fator})`;
        })
        .join(" · "),
    [composicoesGarantiaAtivas],
  );

  const carregarComposicoesGarantia = useCallback(async () => {
    try {
      const config = { headers: headers() };
      const { data } = await apiOperation.get<ConfiguracaoCompletaGarantias>(
        "configuracao/obter/configuracoes",
        config,
      );
      const payload =
        (data as { valor?: ConfiguracaoCompletaGarantias })?.valor ?? data;
      setComposicoesGarantia(payload?.configuracaoGarantiaComposicao ?? []);
    } catch {
      setComposicoesGarantia([]);
    } finally {
      setComposicoesGarantiaCarregadas(true);
    }
  }, []);

  useEffect(() => {
    if (carregaItensRdp) {
      carregarComposicoesGarantia();
    }
  }, [carregaItensRdp, carregarComposicoesGarantia]);

  useEffect(() => {
    if (
      !composicoesGarantiaCarregadas ||
      tiposGarantiaDisponiveis.length === 0
    ) {
      return;
    }
    setForm((prev) => {
      const filtrados = prev.tiposGarantia.filter((t) =>
        tiposGarantiaDisponiveis.includes(t),
      );
      if (filtrados.length === prev.tiposGarantia.length) return prev;
      return { ...prev, tiposGarantia: filtrados };
    });
  }, [composicoesGarantiaCarregadas, tiposGarantiaDisponiveis]);

  const handleCloseValidationModal = () => {
    setValidationModalOpen(false);
    setValidationModalMessage("");
  };

  const [modalState, setModalState] = useState({
    open: false,
    title: "",
    message: "",
    existingId: "",
    buttonContinue: "",
    buttonExisting: "",
    buttonClose: "",
    buttonPurchase: "",
  });

  const [errorApi, setErrorApi] = useState({
    message: "",
    title: "",
    state: false,
  });

  // Função isolada de validação, para não misturar os states de cnpj e cnpjSolidário.
  const validateCnpjCpf = (
    value: string,
    checkSimplificada: boolean = false,
  ) => {
    const cleanValue = value.replace(/[^\d]+/g, "");
    let isValid = false;
    let msg = "CNPJ/CPF não é válido.";

    if (cleanValue.length === 11) {
      if (checkSimplificada) {
        isValid = false;
        msg = "Risk Check aceita apenas CNPJ.";
      } else {
        isValid = isCpf(cleanValue);
        msg = isValid ? "" : "CPF não é válido.";
      }
    } else if (cleanValue.length === 14) {
      isValid = isCnpj(cleanValue);
      msg = isValid ? "" : "CNPJ não é válido.";
    }

    return { isValid, msg };
  };

  const bloquearCpfNoTouch = () => {
    if (!cpfBloqueadoNoTouch(form.cnpj)) return false;
    setIsValid(false);
    setErrorMessage(mensagemCpfNoTouch);
    setValidationModalMessage(mensagemCpfNoTouch);
    setValidationModalOpen(true);
    return true;
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;

    if (name === "cnpj") {
      const isSimplificada =
        form.tipoAnalise === EtipoFluxoAnalise.Simplificada;
      const result = validateCnpjCpf(value, isSimplificada);
      const bloqueadoNoTouch = cpfBloqueadoNoTouch(value);

      setIsValid(result.isValid && !bloqueadoNoTouch);
      setErrorMessage(
        bloqueadoNoTouch
          ? mensagemCpfNoTouch
          : result.isValid
            ? ""
            : isNoTouch && !isSimplificada
              ? "CNPJ não é válido."
              : result.msg,
      );
    }

    if (name === "cnpjSolidario") {
      const result = validateCnpjCpf(value, false);

      setIsValidSolidario(result.isValid);
      setErrorMessage(result.isValid ? "" : "CNPJ/CPF não é válido.");
    }

    if (
      name === "prazoDePagamento" ||
      name === "prazoSolicitado" ||
      name === "numeroFuncionarios"
    ) {
      const numericText = value === "" ? "" : value.replace(/[^0-9]/g, "");
      event.target.value = numericText;
    }

    if (name === "valorMedioCompradoTrombini") {
      const numericText = value === "" ? "" : value.replace(/[^0-9]/g, "");
      event.target.value = numericText;
    }

    if (name === "tempoRelacionamento") {
      const numericText = value === "" ? "" : value.replace(/[^0-9]/g, "");
      event.target.value = numericText;
    }

    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleChangeClassificacaoInterna = (event: any) => {
    setForm({ ...form, classificacaoInterna: event.target.value });
  };

  const handleChangeTipoDeAnalise = (event: any) => {
    setForm({ ...form, tipoDeAnalise: event.target.value });
  };

  const handleChangeTipoFluxoAnalise = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const tipoAnalise = Number(event.target.value) as EtipoFluxoAnalise;
    setForm((formAtual) => ({ ...formAtual, tipoAnalise }));
    setAnaliseId("");
    setHasError(true);

    // Revalida o campo CNPJ/CPF quando alterar o tipo de análise selecionado
    if (form.cnpj) {
      const isSimplificada = tipoAnalise === EtipoFluxoAnalise.Simplificada;
      const result = validateCnpjCpf(form.cnpj, isSimplificada);
      setIsValid(result.isValid);
      setErrorMessage(result.isValid ? "" : result.msg);
    }
  };

  const handleChangeRazaoSocial = (event: any) => {
    setForm({ ...form, razaoSocial: event.target.value });
  };

  const handleChangeDemanda = (event: any) => {
    setForm({ ...form, demanda: event.target.value });
  };

  const handleChangeTipoEmpresa = (event: any) => {
    if (event.target.value === "filial") {
      setTipoEmpresa(false);
      setForm({ ...form, tipoEmpresa: event.target.value });
    } else {
      setTipoEmpresa(true);
      setForm({ ...form, tipoEmpresa: event.target.value });
    }
  };

  const handleInputChange = () => {
    setHasUnsavedChanges(true);
  };

  const handleSaveChanges = () => {
    // Lógica para salvar as alterações
    setHasUnsavedChanges(false);
  };

  useEffect(() => {
    usuarioLogado = getSessionUser();
    if (usuarioLogado?.empresa === Empresas.Simpress) {
      setCarregaItens(true);
    } else if (usuarioLogado?.empresa === Empresas.Brf) {
      getOptions();
      setCarregaItensBrf(true);
    } else if (usuarioLogado?.empresa === Empresas.Triunfante) {
      setCarregaItensTriunfante(true);
    } else if (usuarioLogado?.empresa === Empresas.BRT) {
      setCarregaItensBRT(true);
      if (usuarioLogado?.perfil === "Agencia-brt") {
        setcarregaItensAgenciaBRT(true);
      }
    } else if (usuarioLogado?.empresa === Empresas.JnsSeguradora) {
      setCarregaItensJnsSeguradora(true);
    } else if (usuarioLogado?.empresa === Empresas.Trombini) {
      setCarregarItensTrombini(true);
    } else if (usuarioLogado?.empresa === Empresas.Rdp) {
      setCarregaItensRdp(true);
    }
  }, []);

  const getOptions = async (params = "") => {
    try {
      const config = {
        headers: headers(),
      };

      let urlString = "configuracao/obter/ativos";

      const { data } = await apiOperation.get<response>(urlString, config);

      if (data) {
        setOpcaoConfiguracao(data.valor);
      }
    } catch (error: any) {}
  };

  const serviceFile = async (
    file: File,
    controler: any,
    tipoArquivo: string,
    idanalise: string = "",
  ) => {
    const formBody = new FormData();
    formBody.append("arquivo", file, file.name);

    controler(true);
    try {
      setLoadingModal(true);
      setMessagesLoading("Salvando documento...");

      const config = {
        headers: headers(),
      };

      var analise = idanalise != "" ? idanalise : analiseId;

      const response = await apiExtractor.post(
        `documento/upload?analiseId=${analise}&tipoDocumento=${tipoArquivo}`,
        formBody,
        config,
      );

      const { data } = response;

      if (!data.erro) {
        setHasError(false);
        setLoadingModal(false);
        controler(false, file.name);

        const minhaAncora = document.getElementById("minhaAncora");
        if (minhaAncora) {
          minhaAncora.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        setOpen(true);
        setLoadingModal(false);
        const msgError = data.erros?.map((err: string) => err);
        setErrorMsg(msgError);
        setTitleError("Falha no Upload do Arquivo!");
      }
    } catch (error) {
      setLoadingModal(false);
      const msgError = `Falha no upload do arquivo ${file.name}. \n Erro: ${error} `;
      setErrorMsg(msgError);
      setTitleError("Falha no Upload do Arquivo!");
      controler(false);
    }
  };

  const postAnalyze = async () => {
    if (bloquearCpfNoTouch()) return;
    try {
      if (carregaItensAgenciaBRT) {
        var saldo = await getSaldo();
        if (!saldo || saldo <= 0) {
          setHasError(true);
          openModalSaldoInsuficiente();
          return;
        }
      }

      const config = {
        headers: headers(),
      };
      setMessagesLoading("Processando...");
      setLoadingModal(true);

      var url = `extrator/extrair${
        carregaItensJnsSeguradora ? "/documento" : ""
      }`;
      const { data } = await apiExtractor.post(
        url,
        {
          analiseId: analiseId,
          cnpj: form.cnpj.replace(/\D/g, ""),
        },
        config,
      );

      if (data.erro) {
        setLoadingModal(false);
        setErrorApi({
          title: "Erro ao analisar CNPJ!",
          state: true,
          message: data.erros?.join("<hr />") ?? "Erro ao analisar CNPJ",
        });
        return;
      }

      setMessagesLoading("Redirecionando para página de histórico...");
      setTimeout(() => {
        navigate("/historico");
        setLoadingModal(false);
      }, 2000);
    } catch (error) {
      setLoadingModal(false);
      setErrorApi({
        title: "Falha ao analisar CNPJ!",
        state: true,
        message: `Erro: ${error}`,
      });
    }
  };

  const analisarAnaliseSimplificada = async (idAnalise: string) => {
    setMessagesLoading("Realizando Risk Check...");
    setLoadingModal(true);

    const { data } = await apiOperation.post(
      "/analise/analisar",
      { analiseId: idAnalise },
      { headers: headers() },
    );

    if (data.erro) {
      throw data.erros?.join("; ") ?? "Erro ao realizar o Risk Check.";
    }

    setMessagesLoading("Redirecionando para página de histórico...");
    navigate("/historico");
  };

  const handleBalancos = ({ target }: any) => {
    if (!target.files) {
      return;
    }
    const file = target.files[0];
    if (file.size > maxSize) {
      setErrorOnExit(() => () => {});
      setOpen(true);
      setErrorMsg(
        `O arquivo "${file.name}" excede o tamanho máximo permitido de 40MB. Selecione um arquivo menor para continuar.`,
      );
      setTitleError("Falha no Upload do Arquivo!");
      return;
    }
    serviceFile(file, setTresBalancosLoad, "");
    const { name } = file;
    setTresBalancos(name);
  };

  const handleClose = () => {
    setOpen(false);
    SetEmptyModal();
    setErrorOnExit(() => updateAnaliseStatus);
  };

  const handleCloseNavigate = (route = "/") => {
    setOpen(false);
    SetEmptyModal();
    setErrorOnExit(() => updateAnaliseStatus);

    if (route) navigate(route);
  };

  // Função para carregar dados da API
  const carregarDadosSegmentos = useCallback(async () => {
    try {
      const config = {
        headers: headers(),
      };

      setLoadingModal(true);
      setMessagesLoading("Carregando segmentos...");

      const response = await apiOperation.get(
        `analise/lista-segmento?empresaId=${usuarioLogado?.empresa}`,
        config,
      );

      if (response.data && response.data.valor && !response.data.erro) {
        // Se retorna um array de segmentos
        if (Array.isArray(response.data.valor)) {
          setSegmentos(response.data.valor);
        }
        // Se retorna um único segmento, coloca em array
        else {
          setSegmentos([response.data.valor]);
        }
      }
      setLoadingModal(false);
    } catch (error) {
      console.error("Erro ao carregar segmentos:", error);
      setLoadingModal(false);
    }
  }, [empresaId]);

  // Função para selecionar um segmento e preencher o formulário
  const selecionarSegmento = (segmento: ISegmento) => {
    setSegmentoSelecionado(segmento);
    setForm((prevForm) => ({
      ...prevForm,
      segmento: segmento.segmento || "",
      percentualEmbalagem: segmento.porcentagem.toString() || "",
      segmentoId: segmento.segmentoId || "",
    }));
  };

  // Função para lidar com mudanças no campo de segmento
  const handleSegmentoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const segmentoValue = event.target.value;

    const segmentoEncontrado = segmentos.find(
      (seg) => seg.segmento === segmentoValue,
    );

    if (segmentoEncontrado) {
      setSegmentoSelecionado(segmentoEncontrado);
      setForm((prevForm) => ({
        ...prevForm,
        segmento: segmentoValue,
        percentualEmbalagem: segmentoEncontrado.porcentagem.toString() || "",
        segmentoId: segmentoEncontrado.segmentoId,
      }));
    } else {
      setSegmentoSelecionado(null);
      setForm((prevForm) => ({
        ...prevForm,
        segmento: segmentoValue,
        percentualEmbalagem: "",
        segmentoId: "",
      }));
    }
  };

  useEffect(() => {
    if (calcularLimitePorRepresentatividade) {
      carregarDadosSegmentos();
    }
  }, [calcularLimitePorRepresentatividade, carregarDadosSegmentos]);

  async function updateAnaliseStatus(): Promise<void> {
    if (!analiseId) {
      return;
    }

    const config = {
      headers: headers(),
    };

    setLoadingModal(true);
    setMessagesLoading("Atualizando status...");

    var response = await apiOperation.get(
      `analise/atualizar?analiseId=${analiseId}`,
      config,
    );

    if (response.data.valor) {
      setTimeout(() => {
        handleSaveChanges();
        navigate("/historico");
        setLoadingModal(false);
      }, 2000);
    } else {
      setLoadingModal(false);
    }
  }

  const continuarAnalise = () => {
    setHasError(false);
    setLoadingModal(false);

    const minhaAncora = document.getElementById("minhaAncora");

    if (minhaAncora) {
      minhaAncora.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleMoneyValue = (value: any) => {
    if (!value) return "";

    return String(value)
      .replace(/R\$/gi, "") // Remove o 'R$'
      .replace(/\s/g, "") // Remove todos os espaços (normais ou não separáveis)
      .replace(/\./g, "") // Remove os pontos (separadores de milhar)
      .replace(",", "."); // Substitui a vírgula decimal por ponto
  };

  const ValidarAnaliseRetroativa = async () => {
    if (bloquearCpfNoTouch()) return;
    if (formRef.current.tipoAnalise === EtipoFluxoAnalise.Simplificada) {
      await verificarCNPJ();
      return;
    }

    var result = await getHistory();
    if (result.found) openModalAnaliseRetroativa(result.analiseId ?? "");
    else await verificarCNPJ();
  };

  const verificarCNPJ = async () => {
    if (bloquearCpfNoTouch()) return;
    let dadosDoFormulario = { ...formRef.current };

    // Validação de campos obrigatórios para a Análise Simplificada
    if (dadosDoFormulario.tipoAnalise === EtipoFluxoAnalise.Simplificada) {
      if (
        !dadosDoFormulario.valorSolicitado ||
        !dadosDoFormulario.faturamentoMedioMensal ||
        !dadosDoFormulario.prazoSolicitado ||
        !dadosDoFormulario.numeroFuncionarios
      ) {
        setValidationModalMessage(
          "Para o Risk Check, os campos Valor Solicitado, Faturamento Médio Mensal, Prazo Solicitado e Número de Funcionários são obrigatórios.",
        );
        setValidationModalOpen(true);
        return;
      }
    }

    const repMarcado = calcularLimitePorRepresentatividadeRef.current;
    const repDisponivelEmpresa = carregarItensTrombini || carregaItensRdp;

    const campoRepVazio = (v: unknown) =>
      v === undefined || v === null || String(v).trim() === "";

    if (repMarcado && repDisponivelEmpresa) {
      const camposObrigatorios =
        campoRepVazio(dadosDoFormulario.segmento) ||
        campoRepVazio(dadosDoFormulario.percentualEmbalagem) ||
        campoRepVazio(dadosDoFormulario.segmentoId) ||
        campoRepVazio(dadosDoFormulario.valorMedioCompradoTrombini) ||
        campoRepVazio(dadosDoFormulario.prazoDePagamento);

      if (camposObrigatorios) {
        setValidationModalMessage(VALIDATION_MSG_REPRESENTATIVIDADE);
        setValidationModalOpen(true);
        return;
      }
    } else if (!repMarcado) {
      const formularioLimpo = {
        ...dadosDoFormulario,
        segmento: "",
        segmentoId: "",
        percentualEmbalagem: "",
        valorMedioCompradoTrombini: "",
        prazoDePagamento: "",
      };

      dadosDoFormulario = formularioLimpo;

      setForm(formularioLimpo);
    }

    if (carregaItensRdp && dadosDoFormulario.temGarantia) {
      const pct = Number(dadosDoFormulario.percentualCoberturaGarantia);
      const tiposCodigo = mapLabelsParaCodigosGarantia(
        dadosDoFormulario.tiposGarantia,
      );
      const tiposOk = tiposCodigo.length > 0;
      const pctOk =
        dadosDoFormulario.percentualCoberturaGarantia !== "" &&
        Number.isFinite(pct) &&
        pct >= 0 &&
        pct <= 100 &&
        Number.isInteger(pct);
      const outrosSelecionado = tiposCodigo.includes(CODIGO_GARANTIA_OUTROS);
      const descricaoOk =
        !outrosSelecionado ||
        dadosDoFormulario.descricaoGarantia.trim().length > 0;
      if (!tiposOk || !pctOk) {
        setValidationModalMessage(VALIDATION_MSG_GARANTIAS_RDP);
        setValidationModalOpen(true);
        return;
      }
      if (!descricaoOk) {
        setValidationModalMessage(VALIDATION_MSG_GARANTIAS_OUTROS_RDP);
        setValidationModalOpen(true);
        return;
      }

      if (!composicoesGarantiaCarregadas) {
        setValidationModalMessage(
          "Aguarde o carregamento das composições de garantia da parametrização.",
        );
        setValidationModalOpen(true);
        return;
      }

      if (composicoesGarantiaAtivas.length === 0) {
        setValidationModalMessage(
          VALIDATION_MSG_GARANTIAS_SEM_PARAMETRIZACAO_RDP,
        );
        setValidationModalOpen(true);
        return;
      }

      const composicaoEncontrada = buscarComposicaoAtivaPorTipos(
        composicoesGarantiaAtivas,
        tiposCodigo,
      );
      if (!composicaoEncontrada) {
        setValidationModalMessage(VALIDATION_MSG_GARANTIAS_COMBINACAO_RDP);
        setValidationModalOpen(true);
        return;
      }
    }

    setHasLoad(true);
    const body = {
      tipoAnalise: dadosDoFormulario.tipoAnalise,
      cnpjOuCpf: dadosDoFormulario.cnpj.replace(/\D/g, ""),
      ValorSolicitado: handleMoneyValue(dadosDoFormulario.valorSolicitado),
      FaturamentoMedioMensal: handleMoneyValue(
        dadosDoFormulario.faturamentoMedioMensal,
      ),
      PrazoSolicitado: dadosDoFormulario.prazoSolicitado,
      NumeroFuncionarios: dadosDoFormulario.numeroFuncionarios,
      ClassificacaoInterna: dadosDoFormulario.classificacaoInterna,
      ParecerComercial: dadosDoFormulario.parecerComercial,
      UltimoCredito: handleMoneyValue(dadosDoFormulario.ultimoCredito),
      TipoEmpresa: dadosDoFormulario.tipoEmpresa,
      CnpjMatriz: dadosDoFormulario.cnpjMatriz.replace(/\D/g, ""),
      UrlSite: dadosDoFormulario.urlSite,
      TipoDeAnalise: dadosDoFormulario.tipoDeAnalise,
      tempoCooperativa: dadosDoFormulario.tempoCooperativa,
      ComprometimentoRenda: dadosDoFormulario.comprometimentoRenda,
      PostoAtendimento: dadosDoFormulario.postoAtendimento,
      TipoFuncionario: dadosDoFormulario.tipoFuncionario,
      Faturamento: handleMoneyValue(dadosDoFormulario.faturamento),
      CnpjSolidario: dadosDoFormulario.cnpjSolidario,
      TempoRelacionamento: dadosDoFormulario.tempoRelacionamento
        ? Number(dadosDoFormulario.tempoRelacionamento)
        : 0,
      percentualEmbalagem: dadosDoFormulario.percentualEmbalagem,
      valorMedioCompradoTrombini: handleMoneyValue(
        dadosDoFormulario.valorMedioCompradoTrombini,
      ),
      segmento: dadosDoFormulario.segmento,
      segmentoId: dadosDoFormulario.segmentoId,
      prazoDePagamento: dadosDoFormulario.prazoDePagamento,
      NomeConsultaInfoSimples: dadosDoFormulario.razaoSocial,
      CalcularLimiteRepresentatividade: calcularLimitePorRepresentatividade,
      ...(carregaItensRdp
        ? {
            TemGarantia: dadosDoFormulario.temGarantia,
            TiposGarantia: dadosDoFormulario.temGarantia
              ? mapLabelsParaCodigosGarantia(dadosDoFormulario.tiposGarantia)
              : [],
            PercentualCoberturaGarantia: dadosDoFormulario.temGarantia
              ? Number(dadosDoFormulario.percentualCoberturaGarantia)
              : null,
            DescricaoGarantia: dadosDoFormulario.temGarantia
              ? dadosDoFormulario.descricaoGarantia
              : "",
          }
        : {}),
    };
    try {
      setLoadingModal(true);
      setMessagesLoading("Verificando CNPJ...");
      const config = {
        headers: headers(),
      };
      const response = await apiOperation.post(
        `/analise/verificar`,
        body,
        config,
      );

      const { data } = response;

      if (!data.erro) {
        const { valor } = data;
        const { analiseId } = valor;
        setAnaliseId(analiseId);
        handleInputChange();

        if (dadosDoFormulario.tipoAnalise === EtipoFluxoAnalise.Simplificada) {
          await analisarAnaliseSimplificada(analiseId);
          return;
        }

        setHasError(false);
        setLoadingModal(false);
      } else {
        setOpen(true);
        const msgError = data.erros?.map((err: string) => err);
        setErrorMsg(msgError);
        const { valor } = data;
        const { analiseId } = valor;
        setAnaliseId(analiseId);
        setLoadingModal(false);
      }
    } catch (error: any) {
      setHasError(true);
      setOpen(true);
      const msgError = `${error.code}
			Atualize a pagina e tente novamente!`;
      setErrorMsg(msgError);
      setLoadingModal(false);
    }
  };

  const getSaldo = async (): Promise<number | undefined> => {
    try {
      const config = {
        headers: headers(),
      };
      setLoadingModal(true);
      setMessagesLoading("Verificando Saldo...");
      let urlString = `notouch/conta/obter`;

      const { data } = await apiOperation.get<Resultado<Conta>>(
        urlString,
        config,
      );

      if (!data.erro) {
        setLoadingModal(false);
        return data.valor.saldo;
      } else {
        setLoadingModal(false);
        setErrorApi({
          title: "Falha ao obter saldo!",
          state: true,
          message: data.erros?.join("<hr />"),
        });
      }
    } catch (error: any) {
      setLoadingModal(false);
      setErrorApi({
        title: "Falha ao obter saldo!",
        state: true,
        message: `${error.code} Atualize a pagina e tente novamente!`,
      });
    }
  };

  const openModalAnaliseRetroativa = (existingId: string) => {
    setModalState({
      open: true,
      title: "Análise Recente Encontrada",
      message:
        "Já existe uma análise recente (menos de 3 meses). \n Deseja continuar com uma nova?",
      existingId: existingId,
      buttonContinue: "Continuar com a análise",
      buttonExisting: "Ver análise existente",
      buttonClose: "",
      buttonPurchase: "",
    });
  };

  const openModalSaldoInsuficiente = () => {
    setModalState({
      open: true,
      title: "Saldo insuficiente",
      message:
        "Você não possui saldo disponível para realizar a análise. Deseja comprar mais créditos?",
      existingId: "",
      buttonContinue: "",
      buttonExisting: "",
      buttonClose: "Voltar ao início",
      buttonPurchase: "Comprar créditos",
    });
  };

  const SetEmptyModal = () => {
    setModalState({
      open: false,
      title: "",
      message: "",
      existingId: "",
      buttonPurchase: "",
      buttonExisting: "",
      buttonContinue: "",
      buttonClose: "",
    });
  };

  const getHistory = async (params = ""): Promise<HistoryResult> => {
    try {
      const config = {
        headers: headers(),
      };
      setLoadingModal(true);
      setMessagesLoading("Verificando Analise Retroativa...");
      let urlString = `analise/listar
					?pagina=1
					&registrosPorPagina=10&cnpjOuCpf=${form.cnpj.replace(/\D/g, "")}`;

      const { data } = await apiOperation.get<Listar>(urlString, config);

      setLoadingModal(false);
      if (!data.erro && data.valor.dados.length > 0) {
        const now = new Date();
        for (const analise of data.valor.dados) {
          const dataInclusao = new Date(analise.dataInclusao);
          const diffMonths =
            (now.getFullYear() - dataInclusao.getFullYear()) * 12 +
            (now.getMonth() - dataInclusao.getMonth());

          if (diffMonths < 3 && analise.status === "Concluída") {
            return { found: true, analiseId: analise.analiseId };
          }
        }
      }
      return { found: false };
    } catch (error: any) {
      setLoadingModal(false);
      return { found: false };
    }
  };

  const handleContinue = () => {
    handleClose();
    verificarCNPJ();
  };

  const handleViewExisting = () => {
    window.location.href = `/resultados/${modalState.existingId}`;
  };

  const handleNewUpload = () => {
    setListNewUpload((prev) => {
      const nextId = prev.reduce((m, a) => Math.max(m, a.id), 0) + 1;
      return [
        ...prev,
        {
          id: nextId,
          name: null,
          load: false,
          tipoDocumento: EtipoDocumento.BalancoDre,
        },
      ];
    });
  };

  const handleSetArquivoGenericoLoad = (load: boolean, fileNAme: string) => {
    const _list = listNewUpload.map((arq) => {
      if (arq.name === fileNAme) {
        arq.load = load;
      }
      return arq;
    });
    setListNewUpload(_list);
  };

  const handleArquivoGenerico = async (target: any, id: number) => {
    if (!target.files) {
      return;
    }

    let cnpjInput = document.getElementById("cnpj") as HTMLInputElement;
    let cnpjValue = cnpjInput.value.replace(/\D/g, "");

    if (cnpjValue == "") {
      alert("CNPJ é Obrigatório!");
      return;
    }

    let tipoArquivo = "";

    const validaTipoDoc = listNewUpload.map((arq) => {
      if (arq.id === id) {
        tipoArquivo = arq.tipoDocumento;
      }
      return arq;
    });

    if (tipoArquivo === "") {
      setErrorOnExit(() => () => {});
      setOpen(true);
      const msgError = "Selecione um Tipo de Documento";
      setErrorMsg(msgError);
      setTitleError("Falha no Upload do Arquivo!");

      return;
    }

    const file = target.files[0];

    if (file.size > maxSize) {
      setErrorOnExit(() => () => {});
      setOpen(true);
      setErrorMsg(
        `O arquivo "${file.name}" excede o tamanho máximo permitido de 40MB. Selecione um arquivo menor para continuar.`,
      );
      setTitleError("Falha no Upload do Arquivo!");
      return;
    }

    const { name } = file;
    const newList = listNewUpload.map((arq) => {
      if (arq.id === id) {
        arq.name = name;

        tipoArquivo = arq.tipoDocumento;
      }
      return arq;
    });

    if (analiseId == "") {
      //cria uma analise
      setLoadingModal(true);
      setMessagesLoading("Salvando documento...");

      let body = {
        Cnpj: form.cnpj,
        RazaoSocial: form.razaoSocial,
        Demanda: form.demanda,
      };

      try {
        const config = {
          headers: headers(),
        };

        const response = await apiExtractor.post(
          `extrator/criar`,
          body,
          config,
        );

        const { data } = response;
        if (response.status == 200) {
          setAnaliseId(data);

          setListNewUpload(newList);
          await serviceFile(
            file,
            handleSetArquivoGenericoLoad,
            tipoArquivo,
            data,
          );
        } else {
          setLoadingModal(false);
          const msgError = `Falha no upload do arquivo.`;
          setErrorMsg(msgError);
          setTitleError("Falha no Upload do Arquivo!");
          return;
        }
      } catch (error: any) {
        setLoadingModal(false);
        setOpen(true);
        const msgError = `${error.code}
				Atualize a pagina e tente novamente!`;
        setErrorMsg(msgError);
      }
    } else {
      setListNewUpload(newList);
      await serviceFile(file, handleSetArquivoGenericoLoad, tipoArquivo);
    }

    setLoadingModal(false);
  };

  const isCnpj = (cnpj: string): boolean => {
    const multiplicador1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicador2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let soma: number;
    let resto: number;
    let digito: string;
    let tempCnpj: string;

    cnpj = cnpj.trim().replace(/[^\d]+/g, "");

    if (cnpj.length !== 14) return false;

    tempCnpj = cnpj.substring(0, 12);
    soma = 0;

    for (let i = 0; i < 12; i++) {
      soma += parseInt(tempCnpj[i]) * multiplicador1[i];
    }

    resto = soma % 11;
    resto = resto < 2 ? 0 : 11 - resto;
    digito = resto.toString();
    tempCnpj = tempCnpj + digito;
    soma = 0;

    for (let i = 0; i < 13; i++) {
      soma += parseInt(tempCnpj[i]) * multiplicador2[i];
    }

    resto = soma % 11;
    resto = resto < 2 ? 0 : 11 - resto;
    digito = digito + resto.toString();

    return cnpj.endsWith(digito);
  };

  const isCpf = (cpf: string): boolean => {
    const multiplicador1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicador2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];

    let soma: number;
    let resto: number;
    let digito: string;
    let tempCpf: string;

    cpf = cpf.trim().replace(/[^\d]+/g, "");

    if (cpf.length !== 11) return false;

    tempCpf = cpf.substring(0, 9);
    soma = 0;

    for (let i = 0; i < 9; i++) {
      soma += parseInt(tempCpf[i]) * multiplicador1[i];
    }

    resto = soma % 11;
    resto = resto < 2 ? 0 : 11 - resto;
    digito = resto.toString();
    tempCpf = tempCpf + digito;
    soma = 0;

    for (let i = 0; i < 10; i++) {
      soma += parseInt(tempCpf[i]) * multiplicador2[i];
    }

    resto = soma % 11;
    resto = resto < 2 ? 0 : 11 - resto;
    digito = digito + resto.toString();

    return cpf.endsWith(digito);
  };

  const handleSelectChange =
    (field: keyof IFormfind) => (event: SelectChangeEvent<string>) => {
      setForm((prevForm) => ({
        ...prevForm,
        [field]: event.target.value,
      }));
    };

  const tiposParametros = {
    tempoCooperativa: 111,
    comprometimentoRenda: 109,
    postoAtendimento: 110,
  };

  const opcoesFiltradas = (tipo: number) =>
    opcaoConfiguracao.filter((opcao) => opcao.tipoParametro === tipo);

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const maskedValue = dateMask(event.target.value);
    setForm({ ...form, tempoCooperativa: maskedValue });
  };

  return (
    <>
      <Header />
      <Loading
        mode="blurry"
        hidden={!loadingModal}
        messages={messagesLoading}
      />
      <Container>
        <Title>Nova Análise de Crédito</Title>

        <Card sx={pageCardSx}>
          <CardContent sx={pageCardContentSx}>
            <Paper variant="outlined" sx={{ ...formSectionPanelSx, mt: 0 }}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Tipo de análise</FormLabel>
                <RadioGroup
                  row
                  value={String(form.tipoAnalise)}
                  onChange={handleChangeTipoFluxoAnalise}
                >
                  <FormControlLabel
                    value={String(EtipoFluxoAnalise.Completa)}
                    control={<Radio />}
                    label="Completa"
                  />
                  <FormControlLabel
                    value={String(EtipoFluxoAnalise.Simplificada)}
                    control={<Radio />}
                    label="Risk Check"
                  />
                </RadioGroup>
              </FormControl>
              <Alert severity="info" sx={{ mt: 1.5 }}>
                {form.tipoAnalise === EtipoFluxoAnalise.Simplificada ? (
                  <>
                    <strong>Risk Check:</strong> utiliza Receita Federal e
                    consultas InfoSimples.
                  </>
                ) : (
                  <>
                    <strong>Análise completa:</strong> utiliza Receita Federal,
                    bureaus de crédito e, opcionalmente, balanço patrimonial e
                    DRE.
                  </>
                )}
              </Alert>
            </Paper>
            {!carregaItensJnsSeguradora && (
              <Box
                component="section"
                sx={{ display: "flex", flexDirection: "column", gap: 0 }}
              >
                <SubTitle>
                  {isNoTouch
                    ? "Digite o CNPJ que deseja pesquisar"
                    : "Digite o CNPJ ou CPF que deseja pesquisar"}
                </SubTitle>
                <ContainerForm>
                  <Grid
                    container
                    spacing={{ xs: 2, md: 2.5 }}
                    sx={{ marginTop: "0.25em", width: "100%" }}
                  >
                    <Grid item xs={12} sm={6} md={4} lg={2.6} xl={2}>
                      <div style={{ padding: "10px" }}>
                        <TextField
                          id="cnpj"
                          label={
                            isNoTouch ||
                            form.tipoAnalise === EtipoFluxoAnalise.Simplificada
                              ? "CNPJ"
                              : "CNPJ ou CPF"
                          }
                          variant="outlined"
                          name="cnpj"
                          type="text"
                          fullWidth
                          style={InputStyled}
                          value={cnpjMask(form.cnpj)}
                          onChange={handleChange}
                          error={!isValid}
                          helperText={
                            cpfBloqueadoNoTouch(form.cnpj)
                              ? mensagemCpfNoTouch
                              : !isValid && errorMessage
                          }
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={2.6} xl={2}>
                      <div style={{ padding: "10px" }}>
                        <TextField
                          {...(form.tipoAnalise ===
                          EtipoFluxoAnalise.Simplificada
                            ? { required: true }
                            : {})}
                          id="valorSolicitado"
                          label="Valor Solicitado"
                          variant="outlined"
                          name="valorSolicitado"
                          type={"text"}
                          fullWidth
                          style={InputStyled}
                          value={form.valorSolicitado}
                          onChange={handleChange}
                          onInput={mascaraMoeda}
                        />
                      </div>
                    </Grid>

                    {form.tipoAnalise === EtipoFluxoAnalise.Simplificada && (
                      <>
                        <Grid item xs={12} sm={6} md={4} lg={2.6} xl={2}>
                          <div style={{ padding: "10px" }}>
                            <TextField
                              required
                              id="faturamentoMedioMensal"
                              label="Faturamento Médio Mensal"
                              variant="outlined"
                              name="faturamentoMedioMensal"
                              type={"text"}
                              fullWidth
                              style={InputStyled}
                              value={form.faturamentoMedioMensal}
                              onChange={handleChange}
                              onInput={mascaraMoeda}
                            />
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={2.6} xl={2}>
                          <div style={{ padding: "10px" }}>
                            <TextField
                              required
                              id="prazoSolicitado"
                              label="Prazo Solicitado (dias)"
                              variant="outlined"
                              name="prazoSolicitado"
                              type={"text"}
                              fullWidth
                              style={InputStyled}
                              value={form.prazoSolicitado}
                              onChange={handleChange}
                            />
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={2.6} xl={2}>
                          <div style={{ padding: "10px" }}>
                            <TextField
                              required
                              id="numeroFuncionarios"
                              label="Número de Funcionários"
                              variant="outlined"
                              name="numeroFuncionarios"
                              type={"text"}
                              fullWidth
                              style={InputStyled}
                              value={form.numeroFuncionarios}
                              onChange={handleChange}
                            />
                          </div>
                        </Grid>
                      </>
                    )}

                    <Grid item xs={12} sm={6} md={4} lg={2.6} xl={2}>
                      <div style={{ padding: "10px" }}>
                        <TextField
                          id="ultimoCredito"
                          label="Último Crédito Concedido"
                          variant="outlined"
                          name="ultimoCredito"
                          type={"text"}
                          fullWidth
                          style={InputStyled}
                          value={form.ultimoCredito}
                          onChange={handleChange}
                          onInput={mascaraMoeda}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={2.6} xl={2}>
                      <div style={{ padding: "10px" }}>
                        <TextField
                          id="tempoRelacionamento"
                          label="Tempo de Relacionamento"
                          placeholder="Em meses"
                          variant="outlined"
                          name="tempoRelacionamento"
                          type="text"
                          fullWidth
                          style={InputStyled}
                          value={form.tempoRelacionamento}
                          onChange={handleChange}
                        />
                      </div>
                    </Grid>

                    {carregaItensTriunfante && (
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
                        <div style={{ padding: "10px" }}>
                          <TextField
                            id="faturamento"
                            label="Faturamento"
                            variant="outlined"
                            name="faturamento"
                            type={"text"}
                            style={InputStyled}
                            value={form.faturamento}
                            onChange={handleChange}
                            onInput={mascaraMoeda}
                          />
                        </div>
                      </Grid>
                    )}
                    {carregaItensSimpress && (
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
                        <div style={{ padding: "10px" }}>
                          <TextField
                            id="urlSite"
                            label="Url Site"
                            variant="outlined"
                            name="urlSite"
                            type={"text"}
                            style={InputStyled}
                            value={form.urlSite}
                            onChange={handleChange}
                          />
                        </div>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6} md={4} lg={2.4} xl={3}>
                      <div style={{ padding: "10px" }}>
                        <TextField
                          select
                          fullWidth
                          id="classificacaoInterna"
                          label="Classificação Comercial do Cliente"
                          name="classificacaoInterna"
                          variant="outlined"
                          style={InputStyled}
                          value={form.classificacaoInterna}
                          onChange={handleChangeClassificacaoInterna}
                        >
                          <MenuItem value={EclassificacaoInterna.Otimo}>
                            <Tooltip
                              title={
                                <Box
                                  sx={{
                                    padding: 0,
                                    margin: 0,
                                    "& ul": { paddingLeft: "20px" },
                                    "& li": {
                                      listStyleType: "disc",
                                      display: "list-item",
                                      marginLeft: "10px",
                                    },
                                  }}
                                >
                                  <ul
                                    style={{
                                      paddingLeft: "20px",
                                      marginTop: "5px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Histórico de pagamento: considera um
                                      cliente sem histórico de inadimplência
                                    </li>
                                    <br />
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Recorrência comercial: considera um
                                      cliente que realiza compras de forma
                                      recorrente e frequente
                                    </li>
                                    <br />
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Tempo de cadastro: considera um cliente
                                      com um relacionamento superior a 2 anos
                                    </li>
                                  </ul>
                                </Box>
                              }
                              arrow
                              placement="right"
                            >
                              <span>Estratégico</span>
                            </Tooltip>
                          </MenuItem>
                          <MenuItem value={EclassificacaoInterna.Bom}>
                            <Tooltip
                              title={
                                <Box
                                  sx={{
                                    padding: 0,
                                    margin: 0,
                                    "& ul": { paddingLeft: "20px" },
                                    "& li": {
                                      listStyleType: "disc",
                                      display: "list-item",
                                      marginLeft: "10px",
                                    },
                                  }}
                                >
                                  <ul
                                    style={{
                                      paddingLeft: "20px",
                                      marginTop: "5px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Histórico de pagamento: considera um
                                      cliente com pequenos atrasos (8-30 dias)
                                      frequentes, mas que sempre regulariza
                                      pendências
                                    </li>
                                    <br />
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Recorrência comercial: considera um
                                      cliente que realiza compras esporádicas,
                                      mas com alguma regularidade
                                    </li>
                                    <br />
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Tempo de cadastro: considera um cliente
                                      com um relacionamento entre 1 e 2 anos
                                    </li>
                                  </ul>
                                </Box>
                              }
                              arrow
                              placement="right"
                            >
                              <span>Intermediário</span>
                            </Tooltip>
                          </MenuItem>
                          <MenuItem value={EclassificacaoInterna.Ruim}>
                            <Tooltip
                              title={
                                <Box
                                  sx={{
                                    padding: 0,
                                    margin: 0,
                                    "& ul": { paddingLeft: "20px" },
                                    "& li": {
                                      listStyleType: "disc",
                                      display: "list-item",
                                      marginLeft: "10px",
                                    },
                                  }}
                                >
                                  <ul
                                    style={{
                                      paddingLeft: "20px",
                                      marginTop: "5px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Histórico de pagamento: considera um
                                      cliente com atrasos superiores a 30 dias
                                      ou histórico de inadimplência
                                    </li>
                                    <br />
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Recorrência comercial: considera um
                                      cliente que realiza compras muito
                                      esporádicas ou está inativo.
                                    </li>
                                    <br />
                                    <li
                                      style={{
                                        listStyleType: "disc",
                                        display: "list-item",
                                      }}
                                    >
                                      Tempo de cadastro: considera um cliente
                                      com um relacionamento inferior a 1 ano
                                    </li>
                                  </ul>
                                </Box>
                              }
                              arrow
                              placement="right"
                            >
                              <span>Crítico</span>
                            </Tooltip>
                          </MenuItem>
                        </TextField>
                      </div>
                    </Grid>

                    {carregaItensSimpress && (
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
                        <div style={{ padding: "10px" }}>
                          <InputLabel id="tipoAnaliseLabel">
                            Tipo análise
                          </InputLabel>
                          <Select
                            fullWidth
                            labelId="tipoAnaliseLabel"
                            id="tipoAnalise"
                            value={form.tipoDeAnalise}
                            onChange={handleChangeTipoDeAnalise}
                          >
                            <MenuItem value={EtipoAnalise.Corporate}>
                              {EtipoAnalise.Corporate}
                            </MenuItem>
                            <MenuItem value={EtipoAnalise.Revenda}>
                              {EtipoAnalise.Revenda}
                            </MenuItem>
                            <MenuItem value={EtipoAnalise.Aditivo}>
                              {EtipoAnalise.Aditivo}
                            </MenuItem>
                          </Select>
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </ContainerForm>
                <div>
                  <Grid container spacing={2} alignItems="flex-start">
                    {carregaItensBRT && !carregaItensAgenciaBRT && (
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField
                          id="cnpjSolidario"
                          label="CPF Responsável Solidário"
                          variant="outlined"
                          name="cnpjSolidario"
                          type="text"
                          style={InputStyled}
                          value={cnpjMask(form.cnpjSolidario)}
                          onChange={handleChange}
                          error={!isValidSolidario}
                          helperText={!isValidSolidario && errorMessage}
                        />
                      </Grid>
                    )}
                  </Grid>
                </div>

                <ContainerTextArea>
                  <InputLabel>Parecer Comercial</InputLabel>
                  <TextareaAutosize
                    maxRows={6}
                    minRows={3}
                    id="parecerComercial"
                    name="parecerComercial"
                    aria-label="maximum height"
                    placeholder="Digite o parecer comercial aqui..."
                    value={form.parecerComercial}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                    onChange={handleChange}
                  />
                </ContainerTextArea>

                {carregaItensRdp && (
                  <Box sx={formSectionPanelSx}>
                    <SubTitle>Garantias</SubTitle>
                    <Grid container spacing={2} sx={{ marginTop: "0.5em" }}>
                      <Grid item xs={12}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            Tem Garantia?
                          </FormLabel>
                          <RadioGroup
                            row
                            value={form.temGarantia ? "sim" : "nao"}
                            onChange={(e) => {
                              const sim = e.target.value === "sim";
                              setForm((prev) => ({
                                ...prev,
                                temGarantia: sim,
                                ...(sim
                                  ? {}
                                  : {
                                      tiposGarantia: [],
                                      percentualCoberturaGarantia: "",
                                      descricaoGarantia: "",
                                    }),
                              }));
                            }}
                          >
                            <FormControlLabel
                              value="sim"
                              control={<Radio color="primary" />}
                              label="Sim"
                            />
                            <FormControlLabel
                              value="nao"
                              control={<Radio color="primary" />}
                              label="Não"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {form.temGarantia && (
                        <>
                          {!composicoesGarantiaCarregadas && (
                            <Grid item xs={12}>
                              <Alert severity="info">
                                Carregando composições de garantia da
                                parametrização…
                              </Alert>
                            </Grid>
                          )}
                          {composicoesGarantiaCarregadas &&
                            composicoesGarantiaAtivas.length === 0 && (
                              <Grid item xs={12}>
                                <Alert severity="warning">
                                  {
                                    VALIDATION_MSG_GARANTIAS_SEM_PARAMETRIZACAO_RDP
                                  }
                                </Alert>
                              </Grid>
                            )}
                          {composicoesGarantiaCarregadas &&
                            composicoesGarantiaAtivas.length > 0 && (
                              <Grid item xs={12}>
                                <Alert severity="info" variant="outlined">
                                  Combinações parametrizadas (selecione os tipos
                                  de uma linha): {resumoCombinacoesGarantia}
                                </Alert>
                              </Grid>
                            )}
                          <Grid item xs={12} sm={6} md={8}>
                            <Autocomplete
                              multiple
                              disableCloseOnSelect
                              options={tiposGarantiaDisponiveis}
                              groupBy={(codigo) => getGrupoTipoGarantia(codigo)}
                              getOptionLabel={(codigo) =>
                                getLabelTipoGarantia(codigo)
                              }
                              value={form.tiposGarantia}
                              disabled={
                                !composicoesGarantiaCarregadas ||
                                tiposGarantiaDisponiveis.length === 0
                              }
                              onChange={(_e, value) =>
                                setForm((prev) => ({
                                  ...prev,
                                  tiposGarantia: value,
                                }))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Tipo(s) de Garantia"
                                  placeholder="Selecione o grupo e a opção"
                                  variant="outlined"
                                  fullWidth
                                  helperText="Selecione a classificação da garantia (agrupada por tipo)."
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <NumericFormat
                              customInput={TextField}
                              label="% de cobertura da garantia"
                              variant="outlined"
                              fullWidth
                              suffix="%"
                              allowNegative={false}
                              decimalScale={0}
                              value={form.percentualCoberturaGarantia}
                              onValueChange={(vals) =>
                                setForm((prev) => ({
                                  ...prev,
                                  percentualCoberturaGarantia: vals.value,
                                }))
                              }
                              isAllowed={(values) => {
                                const { floatValue } = values;
                                if (floatValue === undefined) return true;
                                return floatValue >= 0 && floatValue <= 100;
                              }}
                              helperText="Percentual do valor solicitado que está coberto pela garantia."
                            />
                          </Grid>
                          {form.tiposGarantia.includes(
                            CODIGO_GARANTIA_OUTROS,
                          ) && (
                            <Grid item xs={12}>
                              <TextField
                                label="Descrição da garantia"
                                variant="outlined"
                                fullWidth
                                multiline
                                minRows={2}
                                value={form.descricaoGarantia}
                                onChange={(e) =>
                                  setForm((prev) => ({
                                    ...prev,
                                    descricaoGarantia: e.target.value,
                                  }))
                                }
                                helperText="Descreva brevemente qual garantia foi considerada nesta operação."
                              />
                            </Grid>
                          )}
                        </>
                      )}
                      <Grid item xs={12}>
                        <Alert severity="info" sx={{ alignItems: "center" }}>
                          A pontuação usa o peso do critério Garantias, o fator
                          da combinação cadastrada na parametrização e o % de
                          cobertura informado.
                        </Alert>
                      </Grid>
                    </Grid>
                  </Box>
                )}

                {(carregarItensTrombini || carregaItensRdp) && (
                  <Box
                    sx={{
                      mt: 2,
                      mb: 1,
                      py: 1.25,
                      px: 2,
                      borderRadius: "14px",
                      bgcolor: "var(--surface-sunken)",
                      border: "1px solid var(--border-default)",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={calcularLimitePorRepresentatividade}
                          onChange={(e) =>
                            setCalcularLimitePorRepresentatividade(
                              e.target.checked,
                            )
                          }
                          name="calcularLimitePorRepresentatividade"
                          color="primary"
                        />
                      }
                      label="Calcular limite por representatividade"
                    />
                  </Box>
                )}

                {calcularLimitePorRepresentatividade &&
                  (carregarItensTrombini || carregaItensRdp) && (
                    <Box sx={formSectionPanelSx}>
                      <SubTitle>Representatividade</SubTitle>
                      <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item xs={12} sm={6} md={6} lg={3}>
                          <TextField
                            id="segmento"
                            label="Segmento"
                            variant="outlined"
                            name="segmento"
                            select
                            fullWidth
                            value={form.segmento}
                            onChange={handleSegmentoChange}
                            helperText={
                              segmentoSelecionado
                                ? "Selecionado da lista acima"
                                : ""
                            }
                          >
                            <MenuItem key="" value="">
                              <em>Selecione um segmento</em>
                            </MenuItem>
                            {segmentos.length > 0 ? (
                              segmentos.map((segmento) => (
                                <MenuItem
                                  key={segmento.segmentoId}
                                  value={segmento.segmento}
                                >
                                  {segmento.segmento}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>
                                <em>Nenhum segmento encontrado</em>
                              </MenuItem>
                            )}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={3}>
                          <TextField
                            id="percentualEmbalagem"
                            label={
                              carregarItensTrombini
                                ? "% Embalagem"
                                : "% do insumo no custo"
                            }
                            variant="outlined"
                            name="percentualEmbalagem"
                            type="text"
                            fullWidth
                            disabled={true}
                            value={form.percentualEmbalagem}
                            onChange={handleChange}
                            inputProps={{ maxLength: 5 }}
                            helperText={
                              segmentoSelecionado
                                ? "Preenchido automaticamente"
                                : ""
                            }
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={3}>
                          <TextField
                            id="valorMedioCompradoTrombini"
                            label="% Valor médio comprado"
                            placeholder="Percentual"
                            name="valorMedioCompradoTrombini"
                            variant="outlined"
                            type="text"
                            fullWidth
                            value={form.valorMedioCompradoTrombini}
                            onChange={handleChange}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={3}>
                          <TextField
                            id="prazoDePagamento"
                            label="Prazo de Pagamento"
                            placeholder="Em dias"
                            variant="outlined"
                            name="prazoDePagamento"
                            type="text"
                            fullWidth
                            value={form.prazoDePagamento}
                            onChange={handleChange}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  )}

                <Box sx={{ display: "flex", mt: 3, mb: 0.5 }}>
                  {isValid && (
                    <Button
                      className="verify"
                      onClick={() => {
                        ValidarAnaliseRetroativa();
                      }}
                      sx={{
                        minWidth: "10.4em",
                      }}
                    >
                      Verificar
                    </Button>
                  )}
                </Box>

                {hasLoad && (
                  <Loading
                    mode="blurry"
                    hidden={!loadingModal}
                    messages={messagesLoading}
                  />
                )}
              </Box>
            )}

            {carregaItensJnsSeguradora && (
              <ContainerForm>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="cnpj"
                      label="CNPJ"
                      variant="outlined"
                      name="cnpj"
                      type="text"
                      style={InputStyled}
                      fullWidth
                      value={cnpjMask(form.cnpj)}
                      onChange={handleChange}
                      error={!isValid}
                      helperText={!isValid && errorMessage}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="razaoSocial"
                      label="Razão Social"
                      variant="outlined"
                      name="razaoSocial"
                      type="text"
                      style={InputStyled}
                      fullWidth
                      value={form.razaoSocial}
                      onChange={handleChangeRazaoSocial}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" sx={{ mt: 0.5 }}>
                      <InputLabel id="demandaLabel">Urgência</InputLabel>
                      <Select
                        fullWidth
                        labelId="demandaLabel"
                        id="demanda"
                        label="Urgência"
                        value={form.demanda}
                        onChange={handleChangeDemanda}
                      >
                        <MenuItem value={Edemanda.ComDemanda}>
                          {Edemanda.ComDemanda}
                        </MenuItem>
                        <MenuItem value={Edemanda.SemDemanda}>
                          {Edemanda.SemDemanda}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </ContainerForm>
            )}

            {!carregaItensJnsSeguradora &&
              !carregaItensAgenciaBRT &&
              !hasError &&
              form.tipoAnalise !== EtipoFluxoAnalise.Simplificada && (
                <CardContent sx={documentCardContentSx}>
                  <Stack spacing={2} sx={documentSectionStackSx}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="h2"
                        sx={{ textAlign: "left", pr: 1 }}
                      >
                        Documentos da análise
                      </Typography>
                      <Box sx={{ ml: "auto", flexShrink: 0 }}>
                        <Tooltip
                          title={<DocumentacaoRegrasTooltip />}
                          arrow
                          placement="left"
                          componentsProps={{
                            tooltip: { sx: { maxWidth: "none" } },
                          }}
                        >
                          <IconButton
                            size="small"
                            aria-label="Regras da documentação"
                            sx={{ mt: -0.5 }}
                          >
                            <InfoOutlined fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>

                    <Alert severity="info" sx={{ borderRadius: 2 }}>
                      O envio é sempre <strong>balanço patrimonial</strong> e{" "}
                      <strong>DRE</strong>, em PDF. Você pode usar um arquivo
                      único ou PDFs separados. Use &quot;Adicionar outro
                      documento&quot; quando precisar anexar mais de um arquivo.
                    </Alert>

                    <Form>
                      <Stack spacing={2}>
                        {listNewUpload.map((arquivo, index) => (
                          <Paper
                            key={arquivo.id}
                            variant="outlined"
                            sx={{ p: 2, borderRadius: 2 }}
                          >
                            <Stack spacing={1.5}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                  gap: 1,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                >
                                  {listNewUpload.length > 1
                                    ? `Documento ${index + 1}`
                                    : "Anexar PDF"}
                                </Typography>
                                <Chip
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  label="Balanço e DRE · PDF"
                                />
                              </Box>

                              <label htmlFor={`contained-arquivo${arquivo.id}`}>
                                <ButtonUi
                                  variant="outlined"
                                  component="div"
                                  endIcon={<UploadFile />}
                                  sx={{
                                    borderStyle: "dashed",
                                    borderRadius: "12px",
                                    py: 1.5,
                                    width: "100%",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Input
                                    accept=".pdf"
                                    id={`contained-arquivo${arquivo.id}`}
                                    multiple
                                    hidden
                                    type="file"
                                    onChange={({ target }) => {
                                      handleArquivoGenerico(target, arquivo.id);
                                    }}
                                  />
                                  {arquivo.load ? (
                                    <LoadFile>
                                      <Spinner size={25} />
                                    </LoadFile>
                                  ) : (
                                    <Box component="span">
                                      {arquivo.name ||
                                        "Selecionar PDF (balanço e/ou DRE)"}
                                    </Box>
                                  )}
                                </ButtonUi>
                              </label>
                            </Stack>
                          </Paper>
                        ))}
                      </Stack>
                    </Form>

                    {hasLoadDocumento && (
                      <Load>
                        <div>
                          <Spinner size={64} label="Carregando análise" />
                        </div>
                        <div>
                          <span>Enviando documento...</span>
                        </div>
                      </Load>
                    )}

                    {!hasLoadDocumento && (
                      <ButtonUi
                        variant="outlined"
                        color="primary"
                        startIcon={<Add />}
                        onClick={handleNewUpload}
                        sx={{
                          alignSelf: "flex-start",
                          borderRadius: 2,
                          textTransform: "none",
                        }}
                      >
                        Adicionar outro documento (PDF)
                      </ButtonUi>
                    )}
                  </Stack>
                  <Box
                    id="minhaAncora"
                    sx={{
                      width: "100%",
                      mt: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        pt: 2,
                      }}
                    >
                      <Button className="verify" onClick={postAnalyze}>
                        Analisar
                      </Button>
                    </Box>
                  </Box>
                </CardContent>
              )}

            {carregaItensAgenciaBRT &&
              !hasError &&
              form.tipoAnalise !== EtipoFluxoAnalise.Simplificada && (
                <CardContent sx={documentCardContentSx}>
                  <Box
                    id="minhaAncora"
                    sx={{
                      width: "100%",
                      mt: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        pt: 2,
                      }}
                    >
                      <Button className="verify" onClick={postAnalyze}>
                        Analisar
                      </Button>
                    </Box>
                  </Box>
                </CardContent>
              )}

            {carregaItensJnsSeguradora &&
              form.tipoAnalise !== EtipoFluxoAnalise.Simplificada && (
                <CardContent sx={documentCardContentSx}>
                  <Stack spacing={2} sx={documentSectionStackSx}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="h2"
                        sx={{ textAlign: "left", pr: 1 }}
                      >
                        Documentos da análise
                      </Typography>
                      <Box sx={{ ml: "auto", flexShrink: 0 }}>
                        <Tooltip
                          title={<DocumentacaoRegrasTooltip />}
                          arrow
                          placement="left"
                          componentsProps={{
                            tooltip: { sx: { maxWidth: "none" } },
                          }}
                        >
                          <IconButton
                            size="small"
                            aria-label="Regras da documentação"
                            sx={{ mt: -0.5 }}
                          >
                            <InfoOutlined fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>

                    <Alert severity="info" sx={{ borderRadius: 2 }}>
                      O envio é sempre <strong>balanço patrimonial</strong> e{" "}
                      <strong>DRE</strong>, em PDF. Você pode usar um arquivo
                      único ou PDFs separados. Use &quot;Adicionar outro
                      documento&quot; quando precisar anexar mais de um arquivo.
                    </Alert>

                    <Form>
                      <Stack spacing={2}>
                        {listNewUpload.map((arquivo, index) => (
                          <Paper
                            key={arquivo.id}
                            variant="outlined"
                            sx={{ p: 2, borderRadius: 2 }}
                          >
                            <Stack spacing={1.5}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                  gap: 1,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                >
                                  {listNewUpload.length > 1
                                    ? `Documento ${index + 1}`
                                    : "Anexar PDF"}
                                </Typography>
                                <Chip
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  label="Balanço e DRE · PDF"
                                />
                              </Box>

                              <label htmlFor={`contained-arquivo${arquivo.id}`}>
                                <ButtonUi
                                  variant="outlined"
                                  component="div"
                                  endIcon={<UploadFile />}
                                  sx={{
                                    borderStyle: "dashed",
                                    borderRadius: "12px",
                                    py: 1.5,
                                    width: "100%",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Input
                                    accept=".pdf"
                                    id={`contained-arquivo${arquivo.id}`}
                                    multiple
                                    hidden
                                    type="file"
                                    onChange={({ target }) => {
                                      handleArquivoGenerico(target, arquivo.id);
                                    }}
                                  />
                                  {arquivo.load ? (
                                    <LoadFile>
                                      <Spinner size={25} />
                                    </LoadFile>
                                  ) : (
                                    <Box component="span">
                                      {arquivo.name ||
                                        "Selecionar PDF (balanço e/ou DRE)"}
                                    </Box>
                                  )}
                                </ButtonUi>
                              </label>
                            </Stack>
                          </Paper>
                        ))}
                      </Stack>
                    </Form>

                    {hasLoadDocumento && (
                      <Load>
                        <div>
                          <Spinner size={64} label="Carregando análise" />
                        </div>
                        <div>
                          <span>Enviando documento...</span>
                        </div>
                      </Load>
                    )}

                    {!hasLoadDocumento && (
                      <ButtonUi
                        variant="outlined"
                        color="primary"
                        startIcon={<Add />}
                        onClick={handleNewUpload}
                        sx={{
                          alignSelf: "flex-start",
                          borderRadius: 2,
                          textTransform: "none",
                        }}
                      >
                        Adicionar outro documento (PDF)
                      </ButtonUi>
                    )}
                  </Stack>
                  <Box
                    id="minhaAncora"
                    sx={{
                      width: "100%",
                      mt: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        pt: 2,
                      }}
                    >
                      <Button className="verify" onClick={postAnalyze}>
                        Analisar
                      </Button>
                    </Box>
                  </Box>
                </CardContent>
              )}
          </CardContent>
        </Card>
        <ErrorModal
          open={open}
          handleClose={handleClose}
          errorMsg={errorMsg}
          title="Pontos de atenção na análise!"
          onExit={errorOnExit}
          continuarAnalise={continuarAnalise}
        />
        <Modal
          open={modalState.open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ minWidth: "60%" }}
        >
          <Box sx={style}>
            <HeaderModal>
              <SubTitle>{modalState.title}</SubTitle>
              <IconButton sx={{ marginBottom: "30px" }} onClick={handleClose}>
                <Close />
              </IconButton>
            </HeaderModal>
            <Box>
              <Typography>{modalState.message}</Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                  alignItems: "center",
                  paddingTop: "20px",
                }}
              >
                {modalState.buttonPurchase && (
                  <ButtonUi
                    sx={{
                      width: "10.4em",
                      margin: "2%",
                    }}
                    color="secondary"
                    variant="contained"
                    onClick={() => handleCloseNavigate("/compra")}
                  >
                    {modalState.buttonPurchase}
                  </ButtonUi>
                )}

                {modalState.buttonExisting && (
                  <ButtonUi
                    sx={{
                      width: "10.4em",
                      margin: "2%",
                    }}
                    color="secondary"
                    variant="contained"
                    onClick={handleViewExisting}
                  >
                    {modalState.buttonExisting}
                  </ButtonUi>
                )}

                {modalState.buttonContinue && (
                  <ButtonUi
                    sx={{
                      width: "10.4em",
                      margin: "2%",
                    }}
                    color="secondary"
                    variant="contained"
                    onClick={handleContinue}
                  >
                    {modalState.buttonContinue}
                  </ButtonUi>
                )}

                {modalState.buttonClose && (
                  <ButtonUi
                    sx={{
                      width: "10.4em",
                      margin: "2%",
                    }}
                    color="secondary"
                    variant="contained"
                    onClick={() => handleCloseNavigate("/historico")}
                  >
                    {modalState.buttonClose}
                  </ButtonUi>
                )}
              </Box>
            </Box>
          </Box>
        </Modal>
        <Modal
          open={validationModalOpen}
          onClose={handleCloseValidationModal}
          aria-labelledby="validation-modal-title"
          aria-describedby="validation-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              maxWidth: "700px",
              bgcolor: "background.paper",
              borderRadius: "15px",
              p: 4,
              outline: "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <HeaderModal>
              <SubTitle id="validation-modal-title">
                Campos obrigatórios não preenchidos!
              </SubTitle>
              <IconButton
                sx={{ marginBottom: "30px" }}
                onClick={handleCloseValidationModal}
              ></IconButton>
            </HeaderModal>
            <Box id="validation-modal-description">
              <Typography>{validationModalMessage}</Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  paddingTop: "20px",
                }}
              >
                <ButtonUi
                  sx={{
                    width: "10.4em",
                    margin: "2%",
                  }}
                  color="secondary"
                  variant="contained"
                  onClick={handleCloseValidationModal}
                >
                  Fechar
                </ButtonUi>
              </Box>
            </Box>
          </Box>
        </Modal>
        <Error
          hasOpen={errorApi.state}
          handleClose={() => setErrorApi({ ...errorApi, state: false })}
          errorMsg={errorApi.message}
          title={errorApi.title}
        />
      </Container>
    </>
  );
};
